import React, { useState } from 'react';
import { useLanguage } from '../LanguageContext';
import SEO from '../components/SEO';

const WaIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="white">
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
  </svg>
);

const FbIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="white">
    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
  </svg>
);

export default function Contact() {
  const { t } = useLanguage();
  const [formData, setFormData] = useState({ name: '', email: '', phone: '', service: '', message: '', 'bot-field': '' });
  const [status, setStatus] = useState('idle');

  const encode = (data) => {
    return Object.keys(data)
      .map(key => encodeURIComponent(key) + "=" + encodeURIComponent(data[key]))
      .join("&");
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    setStatus('loading');
    
    fetch("/", {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: encode({ "form-name": "contact", ...formData })
    })
      .then(() => setStatus('success'))
      .catch(error => {
        console.error(error);
        setStatus('error');
      });
  };

  const handleChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value });

  return (
    <main className="contact-main">
      <SEO title={t('seo-contact-title')} description={t('seo-contact-desc')} />
      <div className="call-cta">
        <a href="tel:+995511168147" className="call-btn">
          <span className="call-btn-text">{t('contact-call')}</span>
          <span className="call-btn-number">+995 511 16 81 47</span>
        </a>
        <div className="social-links">
          <a href="https://wa.me/995511168147" className="social-link wa-color" target="_blank" rel="noopener noreferrer">
            <WaIcon /> WhatsApp
          </a>
          <a href="https://www.facebook.com/ironwood.ge" className="social-link fb-color" target="_blank" rel="noopener noreferrer">
            <FbIcon /> Facebook
          </a>
        </div>
      </div>

      <div className="contact-card">
        <h1 className="card-title" style={{ textAlign: 'center', fontSize: 'clamp((1.5rem, 4vw, 2rem)', marginBottom: '0.5rem' }}>{t('contact-title')}</h1>
        <p className="card-subtitle">{t('contact-subtitle')}</p>
        {status === 'success' ? (
          <div className="form-success">
            &#10003; Message sent! We will be in touch shortly.
          </div>
        ) : (
          <form onSubmit={handleSubmit} name="contact">
            <input type="hidden" name="form-name" value="contact" />
            <div style={{ display: 'none' }}>
              <label>Don’t fill this out if you're human: <input name="bot-field" onChange={handleChange} /></label>
            </div>
            
            {status === 'error' && (
              <div className="form-error" style={{ color: '#D8000C', backgroundColor: '#FFD2D2', padding: '0.8rem', borderRadius: '8px', marginBottom: '1.2rem', textAlign: 'center', fontSize: '0.9rem', fontWeight: '500' }}>
                There was an error sending your message. Please try again or contact us directly.
              </div>
            )}

            <div className="form-group">
              <label htmlFor="name">{t('contact-name')}</label>
              <input type="text" id="name" name="name" placeholder={t('contact-name-ph')} required value={formData.name} onChange={handleChange} />
            </div>
            <div className="form-group">
              <label htmlFor="email">{t('contact-email')}</label>
              <input type="email" id="email" name="email" placeholder={t('contact-email-ph')} required value={formData.email} onChange={handleChange} />
            </div>
            <div className="form-group">
              <label htmlFor="phone">{t('contact-phone')}</label>
              <input type="tel" id="phone" name="phone" placeholder={t('contact-phone-ph')} required value={formData.phone} onChange={handleChange} />
            </div>
            <div className="form-group">
              <label htmlFor="service">{t('contact-interest')}</label>
              <select id="service" name="service" value={formData.service} onChange={handleChange} required>
                <option value="" disabled>{t('contact-opt-default')}</option>
                <option value="custom">{t('contact-opt-custom')}</option>
                <option value="gazebo">{t('contact-opt-gazebo')}</option>
                <option value="tables">{t('contact-opt-tables')}</option>
                <option value="chairs">{t('contact-opt-chairs')}</option>
                <option value="fences">{t('contact-opt-fences')}</option>
                <option value="lights">{t('contact-opt-lights')}</option>
                <option value="general">{t('contact-opt-general')}</option>
              </select>
            </div>
            <div className="form-group">
              <label htmlFor="message">{t('contact-msg')}</label>
              <textarea id="message" name="message" rows="4" placeholder={t('contact-msg-ph')} required value={formData.message} onChange={handleChange}></textarea>
            </div>
            <button type="submit" className="submit-btn" disabled={status === 'loading'} style={{ opacity: status === 'loading' ? 0.7 : 1, cursor: status === 'loading' ? 'not-allowed' : 'pointer' }}>
              {status === 'loading' ? '...' : t('contact-btn')}
            </button>
          </form>
        )}
      </div>

    </main>
  );
}


